import { render } from "./KoruNumberField.vue?vue&type=template&id=1683efa4&ts=true"
import script from "./KoruNumberField.vue?vue&type=script&lang=ts"
export * from "./KoruNumberField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__